import { LioUserRole, BrokerageUserRole } from '@lio/rule-engine';
import { Item } from '@components/select';

export enum UserType {
  LIOUser = 'LIOUser',
  BrokerageUser = 'BrokerageUser',
  CustomerUser = 'CustomerUser',
}

export type User = {
  firstName: string;
  lastName: string;
  email: string;
  role: string | string[];
  brokerage: undefined | Item;
  type?: UserType;
  idpUserId?: string;
};

export const initialUser: User = {
  firstName: '',
  lastName: '',
  email: '',
  role: [],
  brokerage: undefined,
  type: UserType.LIOUser,
};

export const roles = {
  [UserType.LIOUser]: [
    { value: LioUserRole.LioSales, label: 'LIO Sales' },
    { value: LioUserRole.JrOps, label: 'Jr Ops' },
    { value: LioUserRole.SrOps, label: 'Sr Ops' },
    { value: LioUserRole.Underwriter, label: 'Underwriter' },
    { value: LioUserRole.LIOContractor, label: 'LIO Contractor' },
    { value: LioUserRole.SystemAdmin, label: 'System Admin' },
    { value: LioUserRole.PortalAdmin, label: 'Portal Admin' },
  ],
  [UserType.BrokerageUser]: [
    { value: BrokerageUserRole.CSR, label: 'CSR' },
    { value: BrokerageUserRole.Producer, label: 'Producer' },
    { value: BrokerageUserRole.Principal, label: 'Principal' },
    { value: BrokerageUserRole.Sales, label: 'Sales' },
  ],
  [UserType.CustomerUser]: [],
};
